import {
  CanActivate,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  Router
} from '@angular/router';
import { Injectable } from '@angular/core';
import { take, skipWhile, map } from 'rxjs/operators';

import { AuthService } from '../services/auth.service';
import { Role, userType } from '../models/role';

@Injectable({ providedIn: 'root' })
export class UserRoleGuard implements CanActivate {

  /**
   * Creates an instance of user role guard.
   * @param authService 
   * @param router 
   */
  constructor(private authService: AuthService, private router: Router) { }

  /**
   * Checks if route is restricted by user role
   * if route role and user role are the same, user can access
   * if no, user is redirected to appropriate route
   * @param route 
   * @param state 
   * @returns  
   */
  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {

    // const currentUser = this.authService.currentUserValue;

    return this.authService.LoggedinUser.pipe(
      skipWhile(value => value === null),
      take(1),
      map(currentUser => {
        if (currentUser) {
          // check if route is restricted by role and type
          if ((route.data.roles && route.data.roles.indexOf(currentUser.role.name) === -1)
            || (route.data.types && route.data.types.indexOf(currentUser.role.type) === -1)) {
            // role not authorised so redirect to home page
            if (currentUser.role.name === Role.USER && currentUser.role.type !== userType.SIMPLE) { this.router.navigate(['/dashboard']); }
            if (currentUser.role.name === Role.USER && currentUser.role.type === userType.SIMPLE) { this.router.navigate(['/crop']); }
            if (currentUser.role.name === Role.ROOT) { this.router.navigate(['/root']); }
            if (currentUser.role.name === Role.CUSTOMER) { this.router.navigate(['/customer']); }
            if (currentUser.role.name === Role.MANAGER) { this.router.navigate(['/manager']); }
            if (currentUser.role.name === Role.CLIENT) { this.router.navigate(['/client']); }
            // console.log('ne mozeeee');
            return false;
          }
          // console.log('|mozeeeeeee');
          // authorised so return true
          return true;
        } else {
          // not logged in so redirect to login page with the return url
          this.router.navigate(['/login'], { queryParams: { returnUrl: state.url } });
          return false;
        }
      })
    );
  }
}
